import {
    AgentActivityIcon,
    AgentWorkingActivity,
} from "@components/presence/AgentWorkingActivity";
import { Avatar } from "@design-system/Avatar/Avatar";
import {
    BoardCardActivity,
    type BoardCardActivityItem,
} from "@design-system/Board/BoardCardActivity";
import type { AgentDrawerMode } from "./boardPlaygroundSettings";

const agentIcon = <AgentActivityIcon />;
const personIcon = (
    <Avatar
        name="Mia Chen"
        variant="outline"
        tone="neutral"
        size="xs"
        aria-hidden
    />
);

const TIMELINE_ITEMS: readonly BoardCardActivityItem[] = [
    { id: "reports", icon: agentIcon, label: "Generate reports", isLive: true },
    {
        id: "categorized",
        icon: agentIcon,
        label: "Categorized 125 transactions",
        time: "24m",
    },
    { id: "edited", icon: personIcon, label: "Edited the task", time: "4h" },
    { id: "created", icon: personIcon, label: "Created the task", time: "2d" },
];

/** The playground's sample drawer for a task the agent has in progress. */
export const TaskBoardActivity = ({
    mode,
}: {
    mode: Exclude<AgentDrawerMode, "none">;
}) =>
    mode === "single" ? (
        <AgentWorkingActivity />
    ) : (
        <BoardCardActivity items={TIMELINE_ITEMS} />
    );
